export default {
  // Access Token for accessing the API
  accessToken: false,
  pageTitle: '',
  currentRouteName: '',
  requestTimestamps: {},
  responseTimestamps: {},
  lastChangelogDismissed: false
}
